import { axiosInstance } from '../../App';
import { GetItemsProps } from "medere-ui-framework";

export function getPatientTransferOrderList(offset: number, pageSize: number, params: any) {
    return axiosInstance.post('/api/secured/transferorder/getPatientTransferOrderList', {
        offSet: offset,
        pageSize,
        filters: params.filterDTO,
        sortingFieldInfoList: params.multiSortMeta
    },
        {
            params: {
                sector: params.sector,
                fromDate: params.fromDate,
                fromHour: params.fromHour,
                fromMinute: params.fromMinute
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getLoguedUserId() {
    return axiosInstance.get('/api/secured/transferorder/getLoguedUserId', {
        params: {
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPatientTransferPendingProgressList(offset: number, pageSize: number, params: any) {
    return axiosInstance.post('/api/secured/transferorder/getPatientTransferPendingProgressList', {
        offSet: offset,
        pageSize,
        filters: params.filterDTO,
        sortingFieldInfoList: params.multiSortMeta
    },
        {
            params: {
                sector: params.sector,
                fromDate: params.fromDate,
                toDate: params.toDate
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getSectors({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getSectors', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue ?? ''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPriorities({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getPriorities', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue ?? ''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getSectorById(sector: number) {

    return axiosInstance.get('/api/secured/transferorder/getSectorById', {
        params: {
            offSet: 0,
            pageSize: 0,
            sector
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}
//TODO revisar que funcione en el back
export function savePatientTransfer(patientTransferId: number, medereentity: number, currentsector: number, newsector: number, oxygen: boolean,
    conveyance: string, priorityId: number, observations: string, fromBed: number, toBed: number) {
    return axiosInstance.post('/api/secured/transferorder/savePatientTransfer', null, {
        params: {
            patientTransferId,
            medereentity,
            currentsector,
            newsector,
            oxygen,
            conveyance,
            priorityId,

            observations,
            fromBed,
            toBed
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function getPatientTransferRequestList(fromDate: Date, toDate: Date, pending: number, inProgress: number, finished: number, cancelled: number/*selectedMultiStatus: any*/) {
    return axiosInstance.get('/api/secured/transferorder/getPatientTransferRequestList', {
        params: {
            fromDate,
            toDate,
            pending,
            inProgress,
            finished,
            cancelled
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getStatus(inputText: string, offSet: number, pageSize: number) {
    return axiosInstance.get('/api/secured/transferorder/getStatus', {
        params: {
            offSet: offSet,
            pageSize,
            inputText
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

//TODO revisar que funcione en el back
export function acceptPatientTransfer(patientTransferId: number, userId: number | undefined) {
    return axiosInstance.post('/api/secured/transferorder/acceptPatientTransfer', null, {
        params: {
            patientTransferId,
            userId
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function acceptPatientTransferWhitPhone(patientTransferId: number, stretcherBearerPhone: number) {
    return axiosInstance.post('/api/secured/transferorder/acceptPatientTransferWhitPhone', null, {
        params: {
            patientTransferId,
            stretcherBearerPhone
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function finishOrReturnToPendingPatientTransfer(patientTransferId: number, userId: number, finished: boolean, comments: string) {
    return axiosInstance.post('/api/secured/transferorder/finishOrReturnToPendingPatientTransfer', null, {
        params: {
            patientTransferId,
            finished,
            comments,
            userId
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function cancelPatientTransfer(medereentity: number, statusId: number, cancellationReason: number, cancellationReasonDescription: string) {
    return axiosInstance.post('/api/secured/transferorder/cancelPatientTransfer', null, {
        params: {
            medereentity,

            statusId,
            cancellationReason,
            cancellationReasonDescription
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

//TODO revisar que funcione en el back
export function cancelTransferWithoutFinish(patientTransferId: number, userId: number, cancellationReason: number, cancellationReasonDescription: string) {
    return axiosInstance.post('/api/secured/transferorder/cancelTransferWithoutFinish', null, {
        params: {
            patientTransferId,
            cancellationReason,
            cancellationReasonDescription,
            userId
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function getPhones({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getPhones', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPhoneByUser(userId: number) {
    return axiosInstance.get('/api/secured/transferorder/getPhoneByUser', {
        params: {
            userId
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function saveAssociatedPhone(stretcherbearerphone: number) {
    return axiosInstance.post('/api/secured/transferorder/saveAssociatedPhone', null, {
        params: {
            stretcherbearerphone
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function getBeds({ filterValue, offSet, pageSize, params }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getBeds', {
        params: {
            offSet: offSet,
            pageSize,
            sector: params.sector,
            inputText: filterValue
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getBedById(sector: number, bed: number) {

    return axiosInstance.get('/api/secured/transferorder/getBedById', {
        params: {
            offSet: 0,
            pageSize: 0,
            sector,
            bed
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getReportStretcherBearer(offset: number, pageSize: number, fromDate: any, toDate: any,
    sector: number, _userstretbearer: number, medereentity: number, fromHour: number, fromMinute: number, toHour: number, toMinute: number) {
    return axiosInstance.post('/api/secured/transferorder/getReportStretcherBearer', {
        offSet: offset,
        pageSize
    },
        {
            params: {
                sector,
                _userstretbearer,
                medereentity,
                fromHour,
                fromMinute,
                toHour,
                toMinute,
                fromDate,
                toDate
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getStretcherBearerInformation({ filterValue, offSet, pageSize, params }: GetItemsProps) {
    return axiosInstance.post('/api/secured/transferorder/getStretcherBearerInformation', {
        offSet: offSet,
        pageSize,
        filters: params.filterDTO,
        sortingFieldInfoList: params.multiSortMeta
    },
        {
            params: {
                sector: params.sector,
                patient: params.patient,
                fromDate: params.fromDate,
                toDate: params.toDate,
                _userstretbearer: params._userstretbearer,
                fromHour: params.fromHour,
                fromMinute: params.fromMinute,
                toHour: params.toHour,
                toMinute: params.toMinute,
                filterValue
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getStretcherBearers({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getStretcherBearers', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue ?? ''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getLoguedStretcherBearers() {
    return axiosInstance.get('/api/secured/transferorder/getLoguedStretcherBearers', {
        params: {
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPatients({ filterValue, offSet, pageSize }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getPatients', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue ?? ''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getPercentagesOfConveyances(offset: number, pageSize: number, fromDate: any, toDate: any,
    sector: number, _userstretbearer: number, medereentity: number, fromHour: number, fromMinute: number, toHour: number, toMinute: number) {
    return axiosInstance.post('/api/secured/transferorder/getPercentagesOfConveyances', {
        offSet: offset,
        pageSize
    },
        {
            params: {
                sector,
                _userstretbearer,
                medereentity,
                fromHour,
                fromMinute,
                toHour,
                toMinute,
                fromDate,
                toDate
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getPercentagesOfStatus(offset: number, pageSize: number, fromDate: any, toDate: any,
    sector: number, _userstretbearer: number, medereentity: number, fromHour: number, fromMinute: number, toHour: number, toMinute: number) {
    return axiosInstance.post('/api/secured/transferorder/getPercentagesOfStatus', {
        offSet: offset,
        pageSize
    },
        {
            params: {
                sector,
                _userstretbearer,
                medereentity,
                fromHour,
                fromMinute,
                toHour,
                toMinute,
                fromDate,
                toDate
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getPercentagesOfCancellationReasons(offset: number, pageSize: number, fromDate: any, toDate: any,
    sector: number, _userstretbearer: number, medereentity: number, fromHour: number, fromMinute: number, toHour: number, toMinute: number) {
    return axiosInstance.post('/api/secured/transferorder/getPercentagesOfCancellationReasons', {
        offSet: offset,
        pageSize
    },
        {
            params: {
                sector,
                _userstretbearer,
                medereentity,
                fromHour,
                fromMinute,
                toHour,
                toMinute,
                fromDate,
                toDate
            }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
        })
}

export function getPatientTransferById(patientTransferId: number) {
    return axiosInstance.get('/api/secured/transferorder/getPatientTransferById', {
        params: {
            offSet: 0,
            pageSize: 0,
            patientTransferId
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function sendTokenToServer(currentToken: string) {
    return axiosInstance.post('/api/secured/transferorder/sendTokenToServer', null, {
        params: {
            currentToken,
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function isAllowedToAssignTransfers(actionId: number) {
    return axiosInstance.get('/api/secured/transferorder/isAllowedToAssignTransfers', {
        params: {

            actionId
        }
    }).then(response => {
        return {
            statusCode: response.status,
        }
    })
        .catch(error => {
            console.error('Its not allowed:', error);
            throw error;
        });
}

export function getCancellationReasons({ offSet, pageSize, filterValue }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getCancellationReasons', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function saveTransferFromPatientDate(patientTransferId: number) {
    return axiosInstance.post('/api/secured/transferorder/saveTransferFromPatientDate', null, {
        params: {
            patientTransferId
        }
    })
        .then(response => {
            return {
                statusCode: response.status,
            }
        })
        .catch(error => {
            console.error('Error al guardar los datos:', error);
            throw error;
        });
}

export function hasTransferDateFromPatient(patientTransferId: number) {
    return axiosInstance.get('/api/secured/transferorder/hasTransferDateFromPatient', {
        params: {
            patientTransferId
        }
    }).then(response => {
        return {
            statusCode: response.status,
        }
    })
        .catch(error => {
            console.error('Its has not a transferDateFromPatient:', error);
            throw error;
        });
}

export function hasATransferOrder(medereentity: number) {
    return axiosInstance.get('/api/secured/transferorder/hasATransferOrder', {
        params: {
            medereentity
        }
    }).then(response => {
        return {
            statusCode: response.status,
        }
    })
        .catch(error => {
            console.error('Its not allowed:', error);
            throw error;
        });
}

export function getRelatedPendingProgressPatientTransfers(patientTransferId: number) {
    return axiosInstance.get('/api/secured/transferorder/getRelatedPendingProgressPatientTransfers', {
        params: {
            patientTransferId
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function hasTaskMessageSenderPermission(taskMessageId: number) {
    return axiosInstance.get('/api/secured/transferorder/hasTaskMessageSenderPermission', {
        params: {
            taskMessageId
        }
    }).then(response => {
        return {
            statusCode: response.status,
        }
    })
        .catch(error => {
            console.error('Its not allowed to receive messages:', error);
            throw error;
        });
}

export function getAverageEstimatedDelay() {
    return axiosInstance.get('/api/secured/transferorder/getAverageEstimatedDelay', {
        params: {
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getStretcherBearerInformationForHeatMap(currentSector: number, newSector: number, fromDate: string, toDate: string) {
    return axiosInstance.get('/api/secured/transferorder/getStretcherBearerInformationForHeatMap',
        {
            params: {
                currentSector,
                newSector,
                fromDate,
                toDate
            }
        }
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
    })
}

export function getPatientsList({ filterValue, offSet, pageSize, params }: GetItemsProps) {
    return axiosInstance.get('/api/secured/transferorder/getPatientsList', {
        params: {
            offSet: offSet,
            pageSize,
            inputText: filterValue ?? '',
            fromdate: params.fromDate,
            todate: params.toDate
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function useTransferService() {
  return {
    getPatientTransferOrderList,
    getLoguedUserId,
    getPatientTransferPendingProgressList,
    getSectors,
    getPriorities,
    getSectorById,
    savePatientTransfer,
    getPatientTransferRequestList,
    getStatus,
    acceptPatientTransfer,
    acceptPatientTransferWhitPhone,
    finishOrReturnToPendingPatientTransfer,
    cancelPatientTransfer,
    cancelTransferWithoutFinish,
    getPhones,
    getPhoneByUser,
    saveAssociatedPhone,
    getBeds,
    getBedById,
    getReportStretcherBearer,
    getStretcherBearerInformation,
    getStretcherBearers,
    getLoguedStretcherBearers,
    getPatients,
    getPercentagesOfConveyances,
    getPercentagesOfStatus,
    getPercentagesOfCancellationReasons,
    getPatientTransferById,
    sendTokenToServer,
    isAllowedToAssignTransfers,
    getCancellationReasons,
    saveTransferFromPatientDate,
    hasTransferDateFromPatient,
    hasATransferOrder,
    getRelatedPendingProgressPatientTransfers,
    hasTaskMessageSenderPermission,
    getAverageEstimatedDelay,
    getStretcherBearerInformationForHeatMap,
    getPatientsList,
  }
}
